import * as React from 'react';
import GatsbyImage from 'gatsby-image';
import PropTypes from 'prop-types';

import { GLFOnlineLandscape } from '../vectors';

function CollectionHero({ image, title }) {
  return (
    <article className="relative w-full mx-auto overflow-hidden max-w-7xl">
      <div className="relative">
        <GatsbyImage fluid={image} className="w-full h-full" />
      </div>
      <div
        aria-hidden
        className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient"
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center w-full h-full">
        {title ? (
          <h1 className="px-6 pt-2 pb-3 text-3xl font-bold leading-none text-center text-white uppercase bg-opacity-75 bg-true-black sm:text-5xl">
            {title}
          </h1>
        ) : (
          <GLFOnlineLandscape className="h-24 text-white lg:h-40" />
        )}
      </div>
    </article>
  );
}

CollectionHero.propTypes = {
  image: PropTypes.object.isRequired,
  title: PropTypes.string,
};

export { CollectionHero };
